import React from 'react';
import styled from 'styled-components';
import { Clinic } from 'kb-shared';

import NewLocationCard from '../../components/NewLocationCard';
import VirtualImage from 'kb-shared/images/virtual-image.png';

interface Props {
  clinics?: Clinic[];
  selectedClinic?: Clinic | null;
  clinicsHasAppoinments: boolean;
  showVirtual: boolean;
  onSelectClinic: (clinic: Clinic) => void;
  onSelectVirtual: () => void;
}

const LocationCards = ({
  clinics = [],
  clinicsHasAppoinments,
  selectedClinic,
  onSelectClinic,
  onSelectVirtual,
  showVirtual
}: Props) => {
  let clinicsCards: React.ReactNode[] = [];

  if (clinicsHasAppoinments) {
    clinicsCards = clinics.map(clinic => (
      <NewLocationCard
        key={clinic.id}
        name={clinic.name}
        address={clinic.address}
        imageUrl={clinic.imageUrl}
        selected={selectedClinic?.id === clinic.id}
        onSelect={() => onSelectClinic(clinic)}
      />
    ));
  }

  if (showVirtual) {
    clinicsCards = clinicsCards.concat([
      <NewLocationCard
        key="virtual"
        name="Virtual"
        address="Meet with your Kindbody doctor online"
        imageUrl={VirtualImage}
        selected={false}
        onSelect={onSelectVirtual}
      />
    ]);
  }

  return (
    <LocationContainer centerContent={clinicsCards.length <= 2}>{clinicsCards}</LocationContainer>
  );
};

export default LocationCards;

interface SpaceContentProps {
  centerContent?: boolean;
}

const LocationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: stretch;

  ${(props: SpaceContentProps) => `
    justify-content: ${props.centerContent ? 'space-evenly' : 'flex-start'};
  `}
  margin-top: 40px;
  @media screen and (max-width: 1288px) {
    justify-content: space-evenly;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    flex-direction: column;
  }
  width: 100%;
  min-height: 100px;
`;
